import { render } from "./PaymentMethodForm.vue?vue&type=template&id=f2a882c8&scoped=true"
import script from "./PaymentMethodForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodForm.vue?vue&type=script&lang=js"

import "./PaymentMethodForm.vue?vue&type=style&index=0&id=f2a882c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a882c8"],['__file',"PaymentMethodForm.vue"]])

export default __exports__